import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { getCategoryAndProductId } from 'analytics/snowplow/helpers/itemCategorisation'
import getOrderDataMemberPricingMetadata from './orderMemberPricingMetadata'
import { getOfferById } from 'api/offer'
import { getChannelMarkup } from 'selectors/channelMarkupSelector'
import sanitizeItemContextMetadata from './sanitizeItemContextMetadata'

async function getLeHotelOrderItems(state: App.State, order: App.Order, isMultiCart?: boolean) {
  return await Promise.all(order.items.map(async orderItem => {
    let fullOffer = state.offer.offers[orderItem.offerId]
    const channelMarkup = getChannelMarkup(state)
    if (!fullOffer) {
      fullOffer = await getOfferById(orderItem.offerId, { region: order.regionCode, currentCurrency: order.currencyCode, channelMarkup }) as App.Offer
    }
    const { categoryId, productId } = getCategoryAndProductId(orderItem.offer.parentType, fullOffer)
    const offerLeadPrice = order?.hasFlight && fullOffer?.lowestPriceBundlePackage ? fullOffer?.lowestPriceBundlePackage?.price : fullOffer?.lowestPricePackage?.price
    const geo = fullOffer?.property?.geoData

    const metadata = {
      ...(orderItem.mx && { mx: orderItem.mx }),
      ...(getOrderDataMemberPricingMetadata(orderItem) && { ...getOrderDataMemberPricingMetadata(orderItem) }),
    }

    const numberOfAdults = orderItem.reservation?.adults ?? undefined

    return comluxgroup.createItem_1_1_1(
      {
        offerId: orderItem.offerId,
        categoryId,
        productId,
        duration: orderItem.duration,
        travelStart: orderItem.reservation?.startDate,
        travelEnd: orderItem.reservation?.endDate,
        price: orderItem.total,
        offerLeadPrice,
        offerLeadDuration: fullOffer?.lowestPricePackage?.duration ? String(fullOffer?.lowestPricePackage?.duration) : undefined,
        offerLeadUnit: fullOffer?.saleUnit,
        propertyFees: orderItem.propertyFees,
        currency: order.currencyCode,
        destinationCity: geo?.locality,
        destinationCountry: geo?.country,
        destinationRegion: geo?.administrativeAreaLevel1,
        reservationType: orderItem.reservationType,
        itemId: orderItem.id,
        bookingNumber: order.bookingNumber,
        orderId: order.id,
        numberOfAdults,
        numberOfChildren: numberOfAdults ? orderItem.reservation?.children ?? 0 : undefined,
        numberOfInfants: numberOfAdults ? orderItem.reservation?.infants ?? 0 : undefined,
        metadata: sanitizeItemContextMetadata({
          ...metadata ?? {},
          isMultiCart,
        }),
      },
    )
  }),
  )
}

export default getLeHotelOrderItems
